import React, { useEffect, useState, useRef } from 'react'
import './TravelsEnd.min.css'
import axios from 'axios';
import { Travel } from '../TravelsPlanned/model'
import AttractionsTravelEnd from './AttractionsTravelEnd'
import { IoMdAddCircle } from 'react-icons/io'
import { AiFillEdit, AiFillDelete, AiOutlineAppstoreAdd, AiOutlineClose, AiOutlineArrowDown } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { ipAddress } from '../../ipAddress';

interface Groups {
  id: number;
  name: string;
}
interface Props {
  travelEnd: Travel; // Travel z wielkiej litery zawiera city, date i id.
  //travelsEnd: TravelEnd[];
  group: Groups;
}

interface TravelEnd {
  id: number;
  city: string;
  date: string;
  isDone: number;
}

interface Attractions {
  id: number;
  name: string;
  isDone: number;
  description: string;
}

const GroupAttractionsTravel: React.FC<Props> = ({ group, travelEnd }) => {
  const [attractions, setAttractions] = useState<Attractions[]>([]);
  const [attractionsList, setAttractionsList] = useState<boolean>(false);
  const [attractionsList2, setAttractionsList2] = useState<boolean>(false);
  const [nameAttraction, setNameAttraction] = useState<string>('');
  const [menuEditGroup, setMenuEditGroup] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false);
  const [editGroup, setEditGroup] = useState<string>(group.name);








  


  const updateTravelAttractions2 = () => {

    axios.post(ipAddress + "/getTravelAttractions", {
      groupId: group.id,
    })
      .then((response) => {
        setAttractions(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }
  updateTravelAttractions2();

  

  


  return (

    <div className='listGroup'>
      {attractions.length > 0 ? (
        <div className='nameGroup'><p><span onClick={() => setAttractionsList2(!attractionsList2)}>{group.name}<span className='icon'><AiOutlineArrowDown /></span></span></p></div>
      ) :
        (
          <div></div>)
      }    
    
      {attractionsList2 ? (

        <div>

          {attractions.map((attraction) => (
            <AttractionsTravelEnd 
              attraction={attraction} key={attraction.id}  group={group} />
          ))}
        </div>
      ) : (
        <div></div>
      )
      }




    </div >



  )
}

export default GroupAttractionsTravel